// extracted by mini-css-extract-plugin
export default {"main":"SharedLayout_main__LUb4F","mainAuth":"SharedLayout_mainAuth__UtIvR"};